import { HttpParams } from '@angular/common/http';
import { GetMaterialsValue } from './get-materials.value';

export class GetMaterialsValueDto {
    page: number;
    limit: number;

    constructor(data: GetMaterialsValue) {
        this.page = data.page;
        this.limit = data.limit;
    }

    toHttpParams(): HttpParams {
        return new HttpParams().set('page', this.page).set('limit', this.limit);
    }
}
